import { GLOBAL_TOOLBAR_HEIGHT_NUMBER } from 'nav-meta/constants';
import { isWindowTopLevel } from './utils/isWindowTopLevel';
export const NOTIFICATIONS_BANNER_IFRAME_ID = 'notifications-banner-iframe';
export const ONBOARDING_TOURS_BANNER_ID = 'onboarding-tours-banner';
export const GROWTH_DYNAMIC_UI_ID = 'growth-dynamic-ui';
export const TRIAL_BANNER_ID = 'trial-banner-iframe';
export const HS_NAV_BEFORE_CONTAINER_ID = 'hs-nav-before-container';
export const HS_NAV_CONTAINER_ID = 'hs-nav-v4';
export const rootNavCompNames = {
  GlobalToolbar: 'GlobalToolbar',
  Banners: 'Banners',
  VerticalNav: 'VerticalNav'
};
export const initialState = {
  rootNav: {
    // Properties for components inside Root Nav
    GlobalToolbar: {
      top: 0,
      height: isWindowTopLevel() ? GLOBAL_TOOLBAR_HEIGHT_NUMBER : 0
    },
    Banners: {
      top: 0,
      height: 0
    },
    VerticalNav: {
      top: 0,
      width: 0
    }
    // ... other components inside Root Nav
  },
  externalNav: {
    // Properties for components outside Root Nav
    Banners: {
      top: 0,
      height: 0
    }
    // ... other components outside Root Nav
  }
};